export default "__VITE_ASSET__BGdWJX8$__"